import React from 'react';
import './ContactBanner.css';

function ContactBanner() {
    return (
        <div className='contact-banner-outer d-flex justify-content-end align-items-start flex-column'>
            <div className="contact-banner-inner d-flex justify-content-end align-items-start flex-column">
                <h1 className='header-text'>Get Placed</h1>
                <p className="cta-text">IN one of the top hotels or airlines out there in the world. <br /> Our expert faculty can help you with it.</p>
            </div>
        </div>
    )
}

export default ContactBanner
